import Api from "../api";
let uri = '/api/ed/segmento';

export const getSegmentos = () => {
    return Api.getInstance().executeGetQuery(`${uri}`)
    .then((resp) => resp.data)
    .catch((error) =>
        console.log(error)
    );
}

export const createSegmento = (data) => {
    return Api.getInstance().executeQuery(`${uri}`, data)
    .then((resp) => resp)
    .catch((error) =>
        console.log(error)
    );
}

export const editSegmento = (data)  => {
    return Api.getInstance().executeUpdateQuery(`${uri}`, data)
    .then((resp) => resp)
    .catch((error) =>
        console.log(error)
    );
}




